import { createApp, markRaw } from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
// import Toaster from "@meforma/vue-toaster";
// import BootstrapVue3 from "bootstrap-vue-3";

import '@/assets/scss/tailwind.scss'
import "@/assets/libs/@mdi/font/css/materialdesignicons.min.css";
import '@/assets/libs/@iconscout/unicons/css/line.css'

import './axios'
import { createPinia } from "pinia";

const pinia = createPinia();
pinia.use(({ store }) => {
    store.router = markRaw(router);
});

import Swal from 'sweetalert2';

window.Swal = Swal
const toast = Swal.mixin({
    toast: true,
    position: 'top-start',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
})
window.toast = toast 

const app = createApp(App).use(pinia).use(router);
app.use(VueAxios, axios);
app.mount("#app");

    